export const delay = wait => {
  return new Promise(resolve => {
    setTimeout(resolve, wait);
  });
};